<template>
    <v-card >
      <v-container v-if="sumfurush_card">
        <v-card-title class="pa-0 mb-2">Движение товар в магазине
          <v-divider class="mx-2" inset vertical></v-divider>


          <export-excel
          :data="filteredProducts"
          :worksheet="'Движение товар в магазине '"
          :name="'Движение товар в магазине'"
          :title="'Движение товар в магазине -' + date2"
          :fields="json_fields"
          :auto-width="true"
          >
          <v-icon  color="success" >
              mdi-microsoft-excel
              </v-icon>
      </export-excel>


        </v-card-title>
        <v-row class="mb-2">
          <v-col cols="12" md="3">


            <v-menu
            ref="menu2"
            v-model="menu2"
            :close-on-content-click="false"
            :return-value.sync="date2"
            transition="scale-transition"
            offset-y
            min-width="auto"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="date2"
                label="Дата 2"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
                solo
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="date2"
              no-title
              scrollable
            >
              <v-spacer></v-spacer>
              <v-btn
                text
                color="primary"
                @click="menu2 = false"
              >
                Отмена
              </v-btn>
              <v-btn
                text
                color="primary"
                @click="get_vozvratho"
              >
                OK
              </v-btn>
            </v-date-picker>
          </v-menu>





          </v-col>

          <v-col cols="12" md="3">

            <v-autocomplete
            clearable
            item-color="primary"
            color="primary"
            hide-no-data
            label="Поставщики"
            hide-details
            multiple
            solo
            :items="firmaho"
            item-text="nom"
            item-value="nom"
            @click:clear="get_vozvratho"
            v-model="filters.firma_nom" />




          </v-col>

          <v-col cols="12" md="3">

            <v-autocomplete
            clearable
             item-color="primary"
             color="primary"
             hide-no-data
             hide-details
             multiple
             solo
             :items="categories"
             item-text="nom"
             item-value="nom"
             label="Категория"
             @click:clear="get_vozvratho"
             v-model="filters.kategoria_nom" />

        </v-col>

          <v-col cols="12" md="3">

              <v-text-field
              color="primary"
              prepend-inner-icon="mdi-magnify"
              solo
              v-model="searching"
              label="Поиск"/>

          </v-col>

        </v-row>

        <v-data-table

        :headers="headers"
        :items="filteredProducts"
        class="elevation-1"
        item-key="id_mol"
        :loading="loading"
                  loading-text="Загрузка. Пожалуйста подождите"
                    :footer-props="{
                        'items-per-page-options': [  20, 50, 100],
                        'items-per-page-text':'Строк на странице',
                    }"
                    no-data-text="Данные отсутствуют в таблице"
        :search="searching">


        </v-data-table>
      </v-container>


      <v-container v-if="furush_card" >
        <v-card-title class="pa-0 mb-2"><v-btn
            class="ml-2"
            color="primary"
            fab
            dark
            small
            @click="back_to_sumfurush"
            >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
          <v-divider class="mx-2" inset vertical></v-divider>
          {{ info_mol.nom }}
        </v-card-title>

        <h1>info</h1>
      </v-container>


      <v-snackbar
      v-model="snack"
      :timeout="3000"
      :color="snackColor"
     >
      {{ snackText }}

      <template v-slot:action="{ attrs }">
        <v-btn
          v-bind="attrs"
          text
          @click="snack = false"
        >
          Закрыть
        </v-btn>
      </template>
     </v-snackbar>


    </v-card>



</template>

<script>
export default {

data: () => ({
  loading: false,
  searching: "",
  search: "",
  s_smena: "",

  valutaho: [
    { valuta: "TJS", id_kurb: 1 },
    { valuta: "USD", id_kurb: 2 },
    { valuta: "RUB", id_kurb: 3 },
  ],

  categories:[],


      date1: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu: false,
      date2: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
      menu2: false,



filters: {
fio: "",

valuta: "",
firma_nom: "",
comment: "",
kategoria_nom: "",
},



headers: [
        {
          text: 'Код',
          align: 'start',
          value: 'kod',
        },
        { text: 'Наименование', value: 'nom' },
        { text: 'Кол-во покупок', value: 'pokupka_kol' },
        { text: 'Кол-во продажа', value: 'fur_kol' },
        { text: 'Кол-во возврат от клиента', value: 'voz_kol' },
        { text: 'Кол-во перемещение из склада', value: 'perem_o' },
        { text: 'Кол-во перемещение на складе', value: 'perem_r' },
        { text: 'Остаток', value: 'ost_kones' },

],

    json_fields: {

        'Код': 'kod',
        'Наименовние': 'nom' ,
        'Кол-во покупок': 'pokupka_kol' ,
        'Кол-во продажа': 'fur_kol' ,
        'Кол-во возврат от клиента': 'voz_kol' ,
        'Кол-во перемещение из склада': 'perem_o' ,
        'Кол-во перемещение на складе': 'perem_r' ,
        'Остаток': 'ost_kones' ,
    },

snack: false,
    snackColor: '',
    snackText: '',

loading: false,
vozvratho: [],
klents: [],
partners: [],
smeni: [],
vozvrat: {},
vozvrat_list: [],

furush_card: false,
sumfurush_card: true,
firmaho: [],
info_mol:  {},


}),

mounted(){
  this.get_firmaho();
  this.get_categories();
  this.get_vozvratho();


},

methods: {

  get_categories(){
          this.loading = true;
        axios.get('/api/get_categories',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.categories = response.data.categories;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  get_firmaho(){
          this.loading = true;
        axios.get('/api/get_firmaho1',
                {
                    headers: {
                        "Content-type": "application/json"
                    }
                })
                .then(response => {
                        if(response.data.status){
                            this.loading = false;
                            this.firmaho = response.data.firmaho;
                        }else{
                            this.loading = false;
                            this.snack = true
                            this.snackColor = 'error'
                            this.snackText = "Ошибка получения фирмы"
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                        }
                    })
                    .catch(error => {
                        this.loading = false;
                        this.snack = true
                        this.snackColor = 'error'
                        this.snackText = error.response.data.message;
                            setTimeout(() => {
                                this.snack = false;
                            }, 2000);
                    });
  },

  sumField(key) {
  return  this.filteredProducts.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },

  sumFurush(key) {
  return  this.vozvrat_list.reduce((a, b) => a + parseFloat((b[key] || 0)), 0)
  },






  get_vozvratho(){
          this.vozvratho = [];
          this.loading = true;
          this.$refs.menu2.save(this.date2)

          var sana = {
            end: this.date2
          }

          axios.post('/api/get_mol_dv', sana,
                        {
                            headers: {
                                "Content-type": "application/json"
                            }
                        })
                        .then(response => {
                                if(response.data.status){
                                 this.vozvratho = response.data.tovari
                                    this.loading = false;
                                   // console.log(response.data.tovari)
                                setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }else{
                                    this.loading = false;
                                    this.snack = true
                                    this.snackColor = 'error'
                                    this.snackText = "Не удалось получить данные"
                                    this.vozvratho = [];
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                                }
                            })
                            .catch(error => {
                                this.vozvratho = [];
                                this.loading = false;
                                this.snack = true
                                this.snackColor = 'error'
                                this.snackText = error.response.data.message;
                                    setTimeout(() => {
                                        this.snack = false;
                                    }, 2000);
                            });
                  },





  back_to_sumfurush(){
      this.furush_card = false;
      this.sumfurush_card = true;
      this.info_mol = {};
  },

  get_info( event, {item}){
    this.info_mol = item;
    this.sumfurush_card = false;
    this.furush_card = true;
  },



},

computed: {

  filteredProducts() {
  let filter = this.vozvratho.filter((id_mol) => {
  for (const [key, filterValue] of Object.entries(this.filters)) {
    // if (!filterValue.length) continue;
    if (!filterValue.length && typeof filterValue !== "boolean") continue; // No filters selected -> show all products.
    if (typeof filterValue === "boolean" && !filterValue) continue; // exclude the checkbox value if not true/false

    let dropdownValue = id_mol[key];

    //If its an array
    if (typeof filterValue === "object") {
      //Single value (single dropdown value)
      if (typeof dropdownValue === "string") {
        if (
          filterValue.findIndex((val) => {
            return val === dropdownValue.trim();
          }) === -1
        )
          return false;
        //Multiple values (multiple dropdown values)
      } else if (typeof dropdownValue === "object") {
        for (const filterString of filterValue) {
          if (dropdownValue.indexOf(filterString) === -1) return false;
        }
      }

      //If its a boolean
    } else if (typeof filterValue === "boolean") {
      if (typeof dropdownValue === "string") {
        if (dropdownValue.length == 0 && filterValue) return false;
        if (dropdownValue.length > 0 && !filterValue) return false;
      } else if (filterValue != dropdownValue) return false;

      //If its a string
    } else if (typeof filterValue === "string") {
      if (typeof filterValue === "string") {
        if (!dropdownValue || dropdownValue.indexOf(filterValue) === -1)
          return false;
      }
    }
  }
  return true;
});
return filter;

},


}

}
</script>

<style  scoped>

</style>



